<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { cn } from '@shared/utils';

  export let isOpen = false;
</script>

<button class="flex flex-col" on:click>
  <Icon
    name="three-dots-circle"
    classes="{cn('rotate-0 my-0.5 transition-transform duration-700', { 'rotate-90': isOpen })}"
  />
</button>
